
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import StatsSection from "./Counter";

import NavBar from "../components/NavBar";
import "../css/HomePage.css";

import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


function HomePage() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div>
      {/* Top Info Bar */}
      <div className="bg-light text-dark py-2">
        <div className="container d-flex justify-content-between align-items-center">
          <small>Schedule your Consultation Today | Mura, Puttur</small>
          <small>
            {/* <a href="#appointment" className="text-success text-decoration-none">
              Book an Appointment
            </a> */}
          </small>
        </div>
      </div>


      {/* Hero Section */}
      <section
        className="py-5"
        style={{ background: "linear-gradient(to right, #e0f7fa, #ffffff)" }}
      >
        <div className="container">
          <div className="row align-items-center">
            {/* Left Text */}
            <div className="col-md-6 mb-4 mb-md-0" data-aos="fade-right">
              <h1 className="mb-3 fw-bold text-primary">
                Beyond Aesthetics:{" "}
                <br className="d-none d-md-block" />
                <span className="text-dark">A Journey of Transformation</span>
              </h1>
              <p className="lead text-muted mb-4">
                Dr. Sachin Harekare - Puttur's finest Orthopaedic Specialist.
              </p>
              <a
                href="#appointment"
                className="btn btn-success btn-lg shadow"
              >
                <i className="bi bi-calendar-check-fill me-2"></i>
                Book an Appointment
              </a>
            </div>

            {/* Right Image */}
            <div className="col-md-6 text-center" data-aos="fade-left">
              <img
                src="https://t3.ftcdn.net/jpg/05/82/03/44/360_F_582034439_0bMANtPU9n6zo7uRuJjm7AhxRNZlRU9u.jpg"
                alt="Doctor"
                className="img-fluid rounded shadow"
                style={{ maxHeight: "500px", objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-5 bg-success text-white">
        <div className="container">
          <h2 className="text-center mb-4">Our Achievements</h2>
          <StatsSection />
        </div>
      </section>

      {/* Services Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-4">Our Services</h2>
          <div className="row text-center">
            <div className="col-md-4 mb-4" data-aos="fade-right">
              <img
                src="/gallery/joint-replacement.jpg"
                alt="Joint Replacement"
                className="img-fluid rounded mb-3"
                style={{ maxHeight: "250px", objectFit: "cover" }}
              />
              <h5>Joint Replacement</h5>
              <p>Advanced knee and hip replacement surgeries for better mobility.</p>
            </div>

            <div className="col-md-4 mb-4" data-aos="fade-up">
              <img
                src="/gallery/fracture-management.jpg"
                alt="Fracture Management"
                className="img-fluid rounded mb-3"
                style={{ maxHeight: "250px", objectFit: "cover" }}
              />
              <h5>Fracture Management</h5>
              <p>Comprehensive care for bone injuries using the latest techniques.</p>
            </div>

            <div className="col-md-4 mb-4" data-aos="fade-left">
              <img
                src="/gallery/spine-care.jpg"
                alt="Spine Care"
                className="img-fluid rounded mb-3"
                style={{ maxHeight: "250px", objectFit: "cover" }}
              />
              <h5>Spine Care</h5>
              <p>Personalized treatment for back and neck pain with modern equipment.</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <h2 className="text-center mb-4">About Dr. Sachin Harekare</h2>
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0" data-aos="zoom-in">
              <img
                src="/gallery/about.jpg"
                alt="Dr. Sachin Harekare"
                className="img-fluid rounded shadow"
              />
            </div>
            <div className="col-md-6" data-aos="fade-left">
              <p className="lead">
                With over a decade of experience, Dr. Sachin Harekare is renowned for his dedication to
                orthopaedic excellence. His mission is to provide affordable, world-class treatment
                to every patient who walks through the door.
              </p>
            </div>
          </div>
        </div>
      </section>
      

      {/* Gallery Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-4">Clinic Gallery</h2>
          <div className="row">
            {[1, 2, 3, 4, 5, 6].map((num, index) => (
              <div
                key={num}
                className="col-md-4 mb-4"
                data-aos={index % 2 === 0 ? "flip-left" : "flip-right"}
              >
                <img
                  src={`/gallery/img${num}.jpg`}
                  alt={`Gallery ${num}`}
                  className="img-fluid rounded shadow-sm gallery-img"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      


      
    </div>
  );
}

export default HomePage;
